<div class="col-md-5 container my-5">

        <div class="text-center">
                <button class="btn btn-success" data-toggle="modal" data-target="#dialogFlowModal">Chat</button>
        </div>

        <div class="modal fade" id="dialogFlowModal" tabindex="-1">
                <div class="modal-dialog">
                        <div class="modal-content">
                                <div class="modal-header">
                                        <h3 class="modal-title" id="exampleModalLabel">Covid ChatBot</h3>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                        </button>
                                </div>
                                <div class="modal-body">
                                        <iframe id="dialogflow" allow="microphone;" width="470" height="550"
                                                src="https://console.dialogflow.com/api-client/demo/embedded/cd5e66a7-9b48-4fca-80fc-0c84c6f80fff">
                                        </iframe>
                                </div>
                                <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary"
                                                data-dismiss="modal">Close</button>
                                </div>
                        </div>
                </div>
        </div>
</div>